import moment from 'moment';

export const formatDate = (date) => {
  return moment(date).format('DD.MM.YYYY HH:mm');
}

// formatDateOnly: date without the time part, for values that are dates to begin with
// (due dates, invoice dates) where "00:00" is noise.
export const formatDateOnly = (date) => {
  if (!date) return '';
  return moment(date).format('DD.MM.YYYY');
}

// formatQuantity: "2.0" → "2", "2.5" → "2,5", null → "-"
export const formatQuantity = (value) => {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('fi-FI', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(parseFloat(value));
};

// formatQuantityChange: like formatQuantity but with +/- sign prefix
export const formatQuantityChange = (value) => {
  if (value === null || value === undefined) return '-';
  const num = parseFloat(value);
  const sign = num >= 0 ? '+' : '';
  return sign + new Intl.NumberFormat('fi-FI', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
};

export const getCsrfToken = () => {
  const name = 'csrftoken=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
